import './styles.css'

export default function MediaFloating({ config }) {
    return (
        <div className="media-floating" style={{ ...(config.style || {}) }}>{
            config.content.map((media, i) => {
                const randomY = Math.random() * 60 - 30;
                const randomScale = 0.9 + Math.random() * 0.2;
                const randomDelay = Math.random() * 2; // 0 to 2s
                const randomDuration = 3.5 + Math.random() * 2; // 2.5s to 4.5s
                return (
                    <div
                        className='media-container floating'
                        style={{
                            transform: `translateY(${randomY}px) scale(${randomScale})`,
                            animationDelay: `${randomDelay}s`,
                            animationDuration: `${randomDuration}s`
                        }}
                        key={i}
                    >
                        <img
                            src={media}
                            className='media-float'
                        />
                    </div>
                );
            })
        }</div>
    )
}